import Community from "./community";

export default class Notification {
    id = null;
    user_id = null;
    notifiable_type = null;
    notifiable_id = null;
    meta = {
        division: true,
        collection: true,
        floorplan: true,
        sales_order: true,
        lot: true,
        system_process: true
    }
    notifiable = {};
    created_at = null;
    updated_at = null;
    deleted_at = null;

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.user_id = data?.user_id ?? this.user_id;
        this.notifiable_type = data?.notifiable_type ?? this.notifiable_type;
        this.notifiable_id = data?.notifiable_id ?? this.notifiable_id;
        this.meta = {
            division: data?.meta?.division ?? this.meta.division,
            collection: data?.meta?.collection ?? this.meta.collection,
            floorplan: data?.meta?.floorplan ?? this.meta.floorplan,
            sales_order: data?.meta?.sales_order ?? this.meta.sales_order,
            lot: data?.meta?.lot ?? this.meta.lot,
            system_process: data?.meta?.system_process ?? this.meta.system_process
        };
        this.notifiable = new Community(data?.notifiable) ?? this.notifiable
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        this.deleted_at = data?.deleted_at ?? this.deleted_at;

        return this;
    }

    get active() {
        return (this.id && this.deleted_at === null)
    }

    get any() {
        return Object.values(this.meta).some(meta => meta === true);
    }

    none() {
        this.meta = Object.fromEntries(Object.keys(this.meta).map(meta => [meta, false]))
    }

    all() {
        this.meta = Object.fromEntries(Object.keys(this.meta).map(meta => [meta, true]))
    }
}